export default "__VITE_ASSET__420e1840__"